import ServiceSession from '../types/ServiceSession';
import { serviceState } from './state';

export const sessionDeletionTimestamp = new Map<string, string>();

export function setSessionDeletionTimestamp(
  sessionSid: string,
  timestamp: string,
): void {
  // clean up entries older than 10 minutes when the map reaches 100 records
  const MAX_MAP_SIZE = 100;
  const TTL = 10 * 60 * 1000;
  if (sessionDeletionTimestamp.size >= MAX_MAP_SIZE) {
    const currentTime = new Date().getTime();

    for (const [sid, ts] of sessionDeletionTimestamp.entries()) {
      const timestampDate = new Date(ts).getTime();
      if (currentTime - timestampDate > TTL) {
        sessionDeletionTimestamp.delete(sid);
      }
    }
  }

  sessionDeletionTimestamp.set(sessionSid, timestamp);
}

export function isOfferedSessionDeleted(
  sessionSid: string,
  timestamp: string,
): boolean {
  const deletionTimestamp = sessionDeletionTimestamp.get(sessionSid);
  if (!deletionTimestamp) {
    return false;
  }
  const deletionDate = new Date(deletionTimestamp);
  const offerDate = new Date(timestamp);
  return deletionDate.getTime() >= offerDate.getTime();
}

export function getSession(sessionId: string): ServiceSession | null {
  return serviceState.sessions[sessionId] || null;
}

export function getSessionByConversationSid(
  conversationSid: string,
): ServiceSession | null {
  if (!serviceState.sessions) {
    return null;
  }
  const conversationId = Object.keys(serviceState.sessions).find(
    (conversationId) => {
      return (
        serviceState.sessions[conversationId].conversationSid ===
        conversationSid
      );
    },
  );
  const session = conversationId ? serviceState.sessions[conversationId] : null;
  return session;
}
